import { useQuery } from "@tanstack/react-query";
import { fetchCategories } from "../services/categoryService";

export const useCategories = (page = 1) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["categories", page],
    queryFn: () => fetchCategories(page),
    select: (response) => ({
      categories: response.message?.data || [],
      pagination: {
        current_page: response.message?.current_page,
        total: response.message?.total,
        per_page: response.message?.per_page,
        last_page: response.message?.last_page,
      },
    }),
  });

  return {
    categories: data?.categories || [],
    loading: isLoading,
    error: error?.message || null,
    pagination: data?.pagination || null,
  };
};
